import React, { Component } from 'react'
import _ from 'lodash'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'

import SnackbarForm from 'components/organisms/SnackbarForm'
import Typography from '@material-ui/core/Typography'

import { actions as snackbarActions } from 'store/modules/snackbar'
import { actions as supportActions } from 'store/modules/support'
import { actions as confirmActions } from 'store/modules/confirm'
import { bindStateToProps, bindActionCreators } from 'lib'

class SnackbarContainer extends Component {
  constructor(props) {
    super(props)
    autoBind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { snackbarKey: key, data = {} } = this.props
    const { data: nextData = {} } = nextProps
    const { open } = data[key] || {}
    const { open: nextOpen } = nextData[key] || {}
    return open !== nextOpen || open === true
  }

  onClickHelper = e => {
    const { ConfirmActions, snackbarKey, data = {} } = this.props
    const { message, request = {} } = data[snackbarKey]
    const { helper } = request
    if (!helper || !helper?.message) return
    ConfirmActions.show({
      key: 'public',
      popupMessage: true,
      title: helper?.cond?.errorCode,
      message: (
        <>
          <Typography variant="body2" gutterBottom>
            {helper?.message}
          </Typography>
          <Typography variant="caption" color="textSecondary" display="block">
            오류 내용
          </Typography>
          <Typography variant="caption" color="textSecondary">
            {message}
          </Typography>
        </>
      )
    })
  }

  onClose(e, reason, key) {
    const { SnackbarActions, data = {} } = this.props
    const openSnackbar = _.pickBy(data, d => d.open === true)
    const openSnackbarLength = Object.keys(openSnackbar).length
    if (openSnackbarLength === 1) {
      const [openKey] = Object.keys(openSnackbar)
      return SnackbarActions.setData({ key: openKey, open: false })
    }
    if (openSnackbarLength > 1 && reason !== undefined) {
      return
    }
    SnackbarActions.setData({ key, open: false })
  }

  getWidth = () => {
    return Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    )
  }

  getHeight = () => {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.documentElement.clientHeight
    )
  }

  render() {
    const data = this.props.data[this.props.snackbarKey] || {}
    return (
      <SnackbarForm {...this.props} {...this.state} proxy={this} data={data} />
    )
  }
}
export default connect(
  bindStateToProps({
    channelTalk: ['ChannelIO'],
    snackbar: true
  }),
  bindActionCreators({
    snackbarActions,
    supportActions,
    confirmActions
  })
)(SnackbarContainer)
